var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2666.667,
    height: 1672,
    viewBox: "0 0 2000 1254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.5V77h372v1029h76V617.2l.1-488.7 229.6 230 229.7 230-33.4.6c-18.4.3-107.2.7-197.4.8l-163.8.1 37.8 37.5 37.9 37.4 198.2.1h198.1L1240 920.7l255.2 255.8-40.9.6c-22.4.3-95.4.7-162 .8l-121.3.1v76h829v-76h-372V148h-76v488.7l-.1 488.8L1322.8 896l-229.2-229.5 26.9-.6c14.9-.4 106.9-.7 204.5-.8l177.5-.2-38-37.4-38-37.4-205.1-.1h-205.2L761.1 334.5C620.8 193.9 506 78.5 506 78c0-.6 59.9-1 161.5-1H829V0H0v38.5zM1552 38.5V77h76V0h-76v38.5zM372 1216v38h76v-76h-76v38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/Logo_Black.92cb2d3504f4f17f51b341df11b02487.svg";
export { ForwardRef as ReactComponent };